/* -------------------------------------------------------------------------- */
/*                                 Schema SIMS                                */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sim = new schema.Entity('sims', {}, { idAttribute: 'simCardId' });
export const sims = new schema.Array(sim);
